/**
 * @voltxampere/ui — RF inductor high-Q (Sprint 45-3)
 *
 * Yüksek-Q ferrite-core RF inductor — LC tank circuit + RF
 * filter + matching network için. Mevcut `inductor` schemaType
 * üzerinden modellenir; Q faktörü datasheet meta + Inspector
 * card'ında görünür.
 *
 * Reference: Generic RF inductor — Coilcraft 0805CS-, Würth
 * WE-RFI, AVX/Kyocera. Tipik L = 100 nH, Q > 100 @ 100 MHz, SRF
 * > 1 GHz. RF filter + matching network + VCO tank circuit.
 *
 *   Default mapping → inductor schemaType:
 *     inductance = 100e-9  (100 nH typical RF)
 *
 * Engine zero-diff invariant honored — canonical `inductor` engine
 * type via schemaType. Q factor + SRF Sprint 47+'da datasheet
 * meta üzerinden Inspector'a yansır.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { inductor } from "../inductor.js";
export const rfInductorHighQ = {
    id: "rf-inductor-high-q",
    nameTr: "RF İnduktör High-Q 100nH (Coilcraft-class)",
    nameEn: "RF Inductor High-Q 100nH (Coilcraft-class)",
    shortcut: "L",
    category: "passive",
    viewBox: inductor.viewBox,
    terminals: inductor.terminals,
    defaultLabel: "L",
    defaultValue: "RF-100nH",
    schemaType: "inductor",
    defaultParams: { inductance: 100e-9 },
    renderSVG: () => inductor.renderSVG(),
};
//# sourceMappingURL=rf-inductor-high-q.js.map